// Discrete notification sound using Web Audio API.
// No external assets — uses a short two-note "ping".

let audioCtx = null;
let lastPlayedAt = 0;

function getAudioCtx() {
  if (audioCtx) return audioCtx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    audioCtx = new AC();
  } catch {
    return null;
  }
  return audioCtx;
}

function isMutedPref() {
  try {
    return localStorage.getItem("aj_sound_mute") === "1";
  } catch (e) {
    console.error("[notify] mute read failed:", e);
    return false;
  }
}

export function setSoundMuted(muted) {
  try {
    localStorage.setItem("aj_sound_mute", muted ? "1" : "0");
  } catch (e) { console.error("[notify] mute persist failed:", e); }
}

export function isSoundMuted() {
  return isMutedPref();
}

// V14.8: desbloqueia/retoma o AudioContext no 1º gesto do usuário (política de autoplay
// de iOS/Android/web). Funciona também no webview do Capacitor. Idempotente.
let _unlockBound = false;
export function initSoundUnlock() {
  if (_unlockBound || typeof window === "undefined") return;
  _unlockBound = true;
  const unlock = () => {
    try {
      const ctx = getAudioCtx();
      if (ctx && ctx.state === "suspended") ctx.resume();
    } catch { /* noop */ }
  };
  const opts = { passive: true };
  ["pointerdown", "touchstart", "click", "keydown"].forEach((ev) =>
    window.addEventListener(ev, unlock, opts)
  );
}

/**
 * Discrete "ping" sound — two-note ascending bell, ~250ms total.
 * Throttled to once per 1.5s to avoid spam.
 */
export function playMessageSound() {
  if (isMutedPref()) return;
  const now = Date.now();
  if (now - lastPlayedAt < 1500) return;
  lastPlayedAt = now;
  const ctx = getAudioCtx();
  if (!ctx) return;
  try {
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    const playNote = (freq, start, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, t0 + start);
      gain.gain.linearRampToValueAtTime(0.18, t0 + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, t0 + start + duration);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0 + start);
      osc.stop(t0 + start + duration + 0.05);
    };
    playNote(880, 0, 0.12);    // A5
    playNote(1318.5, 0.1, 0.18); // E6
  } catch {
    // ignore
  }
}

/**
 * Alerta de STATUS/evento importante (ex.: nova solicitação de aluguel) —
 * 3 notas ascendentes, mais chamativo que o "ping" de mensagem, para diferenciar.
 */
export function playStatusSound() {
  if (isMutedPref()) return;
  const now = Date.now();
  if (now - lastPlayedAt < 1500) return;
  lastPlayedAt = now;
  const ctx = getAudioCtx();
  if (!ctx) return;
  try {
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    const playNote = (freq, start, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "triangle";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, t0 + start);
      gain.gain.linearRampToValueAtTime(0.16, t0 + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, t0 + start + duration);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0 + start);
      osc.stop(t0 + start + duration + 0.05);
    };
    playNote(660, 0, 0.14);        // E5
    playNote(880, 0.13, 0.14);     // A5
    playNote(1174.7, 0.26, 0.22);  // D6
  } catch {
    // ignore
  }
}
